import axios from "axios";
import router from "../router";
//单独引入message提示组件
import { Message } from 'element-ui';
import qs from 'qs';
/**
 * 提示函数
 * 禁止点击蒙层、显示一秒后关闭
 */
const tip = msg => {
  // console.log('---进入tip提示---')
  Message({
    showClose: true,
    message: msg,
    type: 'error',
    duration:2000
  });
}
/**
 * 跳转登录页
 * 携带当前页面路由，以期在登录页面完成登录后返回当前页面
 */
const toLogin = () => {
  router.replace({
    path: '/login',
    query: {
      redirect: router.currentRoute.fullPath
    }
  });
}
/**
 * 请求失败后的错误统一处理
 * @param {Number} status 请求失败的状态码
 */
const errorHandle = (status, other) => {
  // console.log("----进入-errorHandle-----::"+status)
  // 状态码判断
  switch (status) {
    // 401: 未登录状态，跳转登录页
    case 401:
      toLogin();
      break;
    // 403 token过期
    // 清除token并跳转登录页
    case 402:
      tip('登录过期');
      window.sessionStorage.clear();
      window.localStorage.clear();
      setTimeout(() => {
        toLogin();
      }, 1000);
      break;
    case 403:
      tip('登录过期，请重新登录');
      window.sessionStorage.clear();
      window.localStorage.clear();
      setTimeout(() => {
        toLogin();
      }, 1000);
      break;
    // 404请求不存在
    case 404:
      tip('请求的资源不存在');
      break;
    case 400:
      tip('400错误');
      break;
    default:
      // console.log(other);
      tip('资源请求错误');
      break;

  }
}

// 创建axios实例
const instance = axios.create({
  timeout: 1000 * 180,//三分钟
  paramsSerializer: {
    serialize:function(params) {// 自定义参数序列化函数
      // console.log('paramsSerializer 被调用了，参数是：', params);
      return qs.stringify(params, { arrayFormat: 'repeat' });
    }
  }
});
//每次请求带上cooki,防止每次请求sessionid不同
instance.defaults.withCredentials=true;
// 设置post请求头
// instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

//请求拦截器
instance.interceptors.request.use(config=>{
  // if(config.method === 'get') {
    // // 手动序列化 params 并添加到 URL 中
    // const queryString = qs.stringify(config.params, { arrayFormat: 'repeat' });
    // // 注意：这里假设你的原始 URL 不包含查询字符串
    // // 如果包含，你需要将其分割出来并重新组合
    // config.url += `?${queryString}`;
    // // 删除 params，因为我们已经手动处理了它们
    // delete config.params;
  // }
  config.headers.Authorization=window.sessionStorage.getItem("token");
  return config;
})
// 响应拦截器
instance.interceptors.response.use(
  // 请求成功
  res => {

    // 1. 判断是否为 blob 类型请求
    // console.log('---进入-响应拦截器---')
    // console.log('---响应拦截器-请求配置---',res.config,res.config.responseType)

    if (res.config.responseType === 'blob') {
      const contentType = res.headers['content-type'] || '';

      // console.log(res.headers,contentType)

      // 2. 解析文件名（从 Content-Disposition 响应头）
      let fileName = '下载文件';
      const contentDisposition = res.headers['content-disposition'];

      if (contentDisposition) {
        // 处理两种常见格式：
        // - filename="xxx.xlsx"
        // - filename*=UTF-8''xxx.xlsx（UTF-8编码）
        const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (match && match[1]) {
          fileName = decodeURIComponent(match[1].replace(/['"]/g, ''));
        }
      }

      // 1. 初步判断：若 Content-Type 是 JSON 类型，直接解析为 Map
      if (contentType.includes('application/json') || contentType.includes('text/json')) {
        // console.log('----转换前---')
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => {
            try {
              // 将 blob 文本解析为 JSON（即后台返回的 Map）
              const mapData = JSON.parse(reader.result);
              // console.log('转换map>>>>',mapData)
              resolve(mapData); // 标记为 map 类型
            } catch (e) {
              reject(new Error('JSON 解析失败，非有效 Map 数据'));
            }
          };
          reader.readAsText(res.data); // 读取 blob 内容为文本

        });
      }


      // console.log('----不用转换-返回---')

      // 3. 返回 blob 对象 + 解析后的文件名
      return Promise.resolve({
        code:0,
        msg:"请求成功",
        blob: res.data,
        fileName: fileName
      });
    }

    return res.status === 200 ? Promise.resolve(res.data) : Promise.reject(res)
  },
  // 请求失败
  error => {
    const { response } = error;
    if (response) {
      // 请求已发出，但是不在2xx的范围
      errorHandle(response.status, response.data.message);
      // return Promise.resolve(response)
      return Promise.reject(response);
    } else {
      // 处理断网的情况
      // eg:请求超时或断网时，更新state的network状态
      // network状态在app.vue中控制着一个全局的断网提示组件的显示隐藏
      // 关于断网组件中的刷新重新获取数据，会在断网组件中说明
      // store.commit('changeNetwork', false);
      window.sessionStorage.setItem("changeNetwork","0");
    }
  });

export default instance;



// WEBPACK FOOTER //
// ./src/request/http.js